import { useState, useEffect, useRef } from 'react';
import styles from "./CustomDropdown.module.css";
import { normalizeOption } from '../../helpers';
import { Body, BodyColor, BodyType } from '../typography/Body';

interface DropdownProps {
    options: any[]; // Array of objects
    selectedValue: any;
    onSelect?: (value: string, label?: string) => void;
    labelKey?: any; // Key for displaying labels
    valueKey?: any; // Key for selecting values
    disabled?: boolean;
    classname?: string;
    id?: string;
    style?: any;
    placeholder?: string;
    name?: string;
    size?: DropdownSize,
}
export enum DropdownSize {
    small,
    large,
}

const getSizeClass = (size: DropdownSize) => {
    let className = "";
    switch (size) {
        case DropdownSize.small:
            className = `${styles.dropdownHeader_small}`;
            break;
        case DropdownSize.large:
            className = `${styles.dropdownHeader_large}`;
            break;
    }
    return className;
}

export const CustomDropdown = ({
    options,
    selectedValue,
    onSelect,
    labelKey,
    valueKey,
    disabled = false,
    classname = "",
    id,
    style = {},
    placeholder,
    name,
    size = DropdownSize.small,
    
}: DropdownProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null);

    const selected = options?.find(opt => normalizeOption(opt, labelKey, valueKey).value === selectedValue)
    const selectedLabel = normalizeOption(selected, labelKey, valueKey)?.label ?? placeholder ?? normalizeOption(options[0], labelKey, valueKey)?.value;

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mouseup', handleClickOutside);
        return () => document.removeEventListener('mouseup', handleClickOutside);
    }, []);

    return (
        <div ref={dropdownRef} className={`${styles.dropdownContainer} ${classname} ${isOpen ? 'open' : ''}`} style={style} id={id}>
            <div
                className={`${selectedLabel === placeholder ? styles.dropdownHeaderPlaceholder : styles.dropdownHeader} ${getSizeClass(size)}`}
                onClick={() => !disabled && setIsOpen(!isOpen)}
                style={{ cursor: disabled ? ' pointer' : 'pointer', pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.6 : 1 }}
            >
                {/* <p className='text-ellipsis mb-0'>{selectedLabel}</p> */}
                <Body
                    type={BodyType.p3}
                    color={BodyColor.secondary}
                    classname=" text-ellipsis mb-0 ff-poppins-medium text-truncate"
                >
                    {name === 'currency' ? `${selectedLabel} (${selected?.symbol || ''})` : (name === 'code' && selected?.symbol) ? `${selectedLabel} ${selected?.symbol || ''}` : `${selectedLabel}`}
                    {/* {selectedLabel} */}
                </Body>
                {/* {isOpen ? <FaCaretUp className="ms-1" /> : <IoCaretDownOutline className="ms-1" />} */}
                <span className="material-symbols-outlined fs-18 icon-gray-0">{`${isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}`}</span>
            </div>
            {isOpen && !disabled && (
                <ul className={styles.dropdownList} style={{...style?.dropdownList}}
>
                    {options?.map((option, index) => {
                        const { label, value } = normalizeOption(option, labelKey, valueKey);
                        return (
                            <li
                                key={index}
                                className={`${styles.dropdownItem} text-ellipsis ${selectedValue === value ? styles.active : ''}`}
                                onClick={() => {
                                    if (onSelect) {
                                        onSelect(value, name);
                                    }
                                    setIsOpen(false);
                                }}
                            >
                                {name === 'currency' ? `${label} (${option.symbol})` : name === 'code' ? `${label} ${option.symbol || ''}` : `${label}`}
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
};

